<template lang="pug">
  //- VinciWorks logo
  a.focus-visible_focus-ring(
    href="https://vinciworks.com/"
    target="_blank"
    role="img"
    aria-label="VinciWorks logo and link to the website"
    v-if="showVinciLogo && !showUploadLogo && !showCustomLogo && !hasCustomGlobalLogo"
  )
    svg.uc-logo.vw-logo(data-name="Layer 2", xmlns="http://www.w3.org/2000/svg", :viewBox=`props.showLogoIcon ? '0 0 121 62.9' : '0 0 500 62.9'`, preserveAspectRatio="xMinYMid", :class="[$attrs.class, vwLogoClasses]" ref="vwLogoRef")
      g
        //- This is the text part of the logo
        g(v-if="!props.showLogoIcon")
          path.cls-1(
          d="M153.74,54.73l-14.92-38.23h9.29l7.91,22.34c.76,2.34,1.28,4.08,1.55,5.22h.16c.38-1.3.92-3.04,1.63-5.22l7.91-22.34h9.29l-14.84,38.23h-8Z")
          path.cls-1(d="M191.02,54.73h-8.56V16.5h8.56v38.23Z")
          path.cls-1(d="M200.56,32.48c0-3.26.68-6.17,2.04-8.72,1.36-2.55,3.33-4.54,5.91-5.95,2.58-1.41,5.61-2.12,9.09-2.12s6.51.71,9.09,2.12c2.58,1.41,4.55,3.4,5.91,5.95,1.36,2.55,2.04,5.46,2.04,8.72v22.26h-8.56v-21.6c0-3.04-.72-5.42-2.16-7.13-1.44-1.71-3.55-2.57-6.32-2.57s-4.88.86-6.32,2.57-2.16,4.09-2.16,7.13v21.6h-8.56v-22.26h0Z")
          path.cls-1(d="M251.39,53.02c-3.02-1.68-5.38-4.05-7.09-7.09-1.71-3.04-2.57-6.47-2.57-10.27s.86-7.23,2.57-10.27c1.71-3.04,4.08-5.42,7.09-7.13s6.4-2.57,10.15-2.57c4.73,0,8.76,1.33,12.11,4s5.45,6.06,6.32,10.19h-8.72c-.82-2.01-2.05-3.59-3.71-4.73-1.66-1.14-3.63-1.71-5.91-1.71-3.26,0-5.97,1.14-8.11,3.42-2.15,2.28-3.22,5.22-3.22,8.8s1.07,6.52,3.22,8.8c2.15,2.28,4.85,3.42,8.11,3.42,2.23,0,4.17-.57,5.83-1.71,1.66-1.14,2.92-2.74,3.79-4.81h8.72c-.87,4.19-2.98,7.6-6.32,10.23-3.34,2.64-7.38,3.95-12.11,3.95-3.75,0-7.13-.84-10.15-2.53h0Z")
          path.cls-1(d="M295.53,54.73h-8.56V16.5h8.56v38.23Z")
          path.cls-1(d="M313.51,54.73l-11.74-38.23h8.97l5.71,21.85c.49,1.85.92,3.89,1.3,6.11h.16c.38-2.23.82-4.27,1.3-6.11l5.79-21.85h9.21l5.79,21.85c.49,1.85.92,3.89,1.3,6.11h.16c.22-1.63.65-3.67,1.3-6.11l5.63-21.85h8.97l-11.74,38.23h-8.72l-5.95-22.91c-.38-1.25-.82-3.15-1.3-5.71h-.16c-.16,1.14-.57,3.05-1.22,5.71l-6.03,22.91h-8.72,0Z")
          path.cls-1(d="M369.27,52.94c-3.05-1.74-5.44-4.13-7.18-7.18-1.74-3.04-2.61-6.41-2.61-10.11s.87-7.06,2.61-10.11c1.74-3.04,4.13-5.45,7.18-7.22,3.04-1.77,6.44-2.65,10.19-2.65s7.23.88,10.27,2.65c3.04,1.77,5.43,4.17,7.18,7.22,1.74,3.05,2.61,6.41,2.61,10.11s-.87,7.07-2.61,10.11c-1.74,3.05-4.13,5.44-7.18,7.18-3.05,1.74-6.47,2.61-10.27,2.61s-7.15-.87-10.19-2.61ZM387.69,44.42c2.17-2.31,3.26-5.23,3.26-8.77s-1.09-6.54-3.26-8.84c-2.17-2.31-4.92-3.46-8.23-3.46s-6.05,1.15-8.19,3.46c-2.15,2.31-3.22,5.26-3.22,8.84s1.07,6.45,3.22,8.77c2.15,2.31,4.88,3.46,8.19,3.46s6.06-1.15,8.23-3.46Z")
          path.cls-1(d="M406.6,31.25c0-4.73,1.34-8.5,4.04-11.33,2.69-2.83,6.32-4.24,10.88-4.24,1.36,0,2.88.19,4.57.57v7.83c-.49-.05-1.47-.08-2.93-.08-2.66,0-4.66.68-5.99,2.04-1.33,1.36-2,3.59-2,6.68v22.01h-8.56v-23.48h0Z")
          path.cls-1(d="M451.99,32.72l16.79,22.01h-10.35l-16.06-21.28v21.28h-8.56V.23h8.56v31.51l14.59-15.24h10.68l-15.65,16.22h0Z")
          path.cls-1(d="M475.22,52.08c-2.83-2.31-4.35-5.34-4.57-9.09h8.4c.22,1.74.96,3.1,2.24,4.08s2.81,1.47,4.61,1.47,3.26-.38,4.24-1.14c.98-.76,1.47-1.71,1.47-2.85,0-1.36-.61-2.39-1.84-3.1-1.22-.7-3.14-1.44-5.75-2.2-2.61-.76-4.76-1.55-6.44-2.36s-3.13-2.01-4.32-3.59c-1.2-1.58-1.79-3.67-1.79-6.28,0-1.96.53-3.8,1.59-5.54,1.06-1.74,2.62-3.14,4.69-4.2,2.07-1.06,4.48-1.59,7.25-1.59,4.02,0,7.31,1.06,9.86,3.18s4.02,5.08,4.4,8.88h-8.4c-.27-1.58-.91-2.81-1.92-3.71-1.01-.9-2.32-1.34-3.95-1.34-1.52,0-2.77.41-3.75,1.22s-1.47,1.85-1.47,3.1c0,1.36.61,2.39,1.84,3.1,1.22.71,3.11,1.41,5.67,2.12,2.61.76,4.77,1.55,6.48,2.36,1.71.82,3.18,2.03,4.4,3.63,1.22,1.6,1.84,3.71,1.84,6.32,0,3.26-1.36,5.91-4.08,7.95-2.72,2.04-6.06,3.06-10.03,3.06-4.29,0-7.85-1.15-10.68-3.46h0Z")
        //- This is the icon part of the logo
        g
          path.cls-2(d="M17.12,0H0l14.84,28.71c2.68,5.08,7.81,7.72,12.67,7.77,5.16.06,10.14-2.82,12.84-8.22L29.72,7.88C27.08,2.76,22.56,0,17.13,0h0Z")
          path.cls-2(d="M64.28,0c-3.8,0-9.06,1.44-12.55,7.74l-11.38,20.52,12.16,23.32c3.85,7.45,11.28,11.31,18.84,11.31,8.4,0,14.94-4.31,19.35-12.16L119.14,0h-54.86Z")

  //- Upload a logo in edit mode
  div(v-else-if="showUploadLogo && !showCustomLogo && !hasCustomGlobalLogo")
    button.ripple.flex.gap-4.items-center.text-xl.py-3.px-5.text-primary-100.border-4.border-dashed.hover_opacity-100.opacity-90.transition.bg-primary-700.bg-opacity-80(
      @click="openLightbox('lightbox-upload-logo')"
      class="border-primary-200/50 ripple_bg-primary-200/20"
    )
      uc-icon.text-current.text-3xl(icon="ic:sharp-file-upload")
      | #{ ' ' }
      uc-text.text-current.text-base.font-sans-serif.uppercase.tracking-wider.font-semibold.pe-4.text-start(
        class="tracking-[0.1em]"
        text="Upload your logo"
      )

  //- Global custom logo - not editable
  uc-asset.uc-logo.custom-global-logo(
    :class="customGlobalLogoClasses"
    :src="customGlobalLogoURL"
    v-else-if="hasCustomGlobalLogo"
  )

  //- Course-specific custom logo (click to upload/edit)
  uc-asset.uc-logo.custom-logo(
    :class="[{ 'cursor-pointer': showCustomLogo && isEditMode }, { 'p-4 rounded-xl': hasLogoLight || hasLogoDark }, { 'bg-white': hasLogoLight }, { 'bg-black': hasLogoDark }]"
    :src="logo"
    @click="isEditMode ? openLightbox('lightbox-upload-logo') : null"
    v-else-if="!hasCustomGlobalLogo && showCustomLogo"
  )
  </template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import useContent from '../stores/useContent';
import { storeToRefs } from 'pinia';
import useEditMode from '../stores/useEditMode';
import openLightbox from '../lib/openLightbox';

const props = defineProps<{
  showLogoIcon?: boolean;
}>();

const { compiled, content } = storeToRefs(useContent());
const { mode } = storeToRefs(useEditMode());
const isEditMode = computed(() => mode.value === 'edit');
const customGlobalLogoURL = inject('customGlobalLogoURL') as Ref<
  string | undefined
>;
const hasCustomGlobalLogo = computed(
  () =>
    !showCustomLogo.value &&
    customGlobalLogoURL.value !== undefined &&
    customGlobalLogoURL.value !== ''
);
const customGlobalLogoClasses = computed(() => {
  // add white, black or no bg depending on the logo filename
  return customGlobalLogoURL.value?.includes('-light')
    ? 'p-4 rounded-xl bg-white'
    : customGlobalLogoURL.value?.includes('-dark')
      ? 'p-4 rounded-xl bg-black'
      : '';
});
const vwLogoRef = ref<SVGElement | null>(null);

const isClosestScreenDark = computed(() => {
  const screen = vwLogoRef.value?.closest('.screen');
  return screen ? screen.classList.contains('dark') : false;
});

const vwLogoClasses = computed(() => {
  return props.showLogoIcon
    ? 'vw-logo-grey'
    : isClosestScreenDark.value
      ? 'vw-logo-white'
      : 'vw-logo-black';
});

const logo = computed(
  () =>
    compiled.value.course['logo-light'] ||
    compiled.value.course['logo-dark'] ||
    compiled.value.course.logo
);

const hasCustomCourseLogo = computed(
  () => logo.value !== true && logo.value !== '' && logo.value !== undefined
);

const showUploadLogo = computed(
  () =>
    (logo.value === true || logo.value === undefined || logo.value === '') &&
    mode.value === 'edit'
);
const showCustomLogo = computed(
  () => logo.value !== '' && logo.value !== true && logo.value !== undefined
);
const showVinciLogo = computed(
  () => logo.value === true || logo.value === undefined
);
const hasLogoLight = computed(() => compiled.value.course['logo-light']);
const hasLogoDark = computed(() => compiled.value.course['logo-dark']);

// we need to clear the default logo prop so light/dark value is picked up
if (hasLogoLight.value || hasLogoDark.value) {
  content.value.course.logo = '';
}
</script>

<style scoped>
.vw-logo {
  max-width: 100%;
}
.vw-logo-grey {
  fill: #a1a1a1;
}
.vw-logo-white {
  fill: #fff;
}
.vw-logo-black {
  fill: #000;
}
</style>
